module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n\n<app-pos></app-pos>"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main